/**
 * Parses rotator image URLs from various input formats.
 * Supports arrays, JSON-encoded arrays, comma-separated URLs, and single URLs.
 */
export const parseRotatorImages = (value) => {
    if (!value)
        return [];
    if (Array.isArray(value)) {
        return value.map((img) => String(img || "").trim()).filter(Boolean);
    }
    if (typeof value === "string") {
        const raw = value.trim();
        if (!raw)
            return [];
        if (raw.startsWith("[") && raw.endsWith("]")) {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) {
                    return parsed.map((img) => String(img || "").trim()).filter(Boolean);
                }
            }
            catch (_a) {
                // Ignore and fallback to CSV parsing.
            }
        }
        const splitByHttp = raw
            .split(/,(?=\s*https?:\/\/)/i)
            .map((img) => img.trim().replace(/^"+|"+$/g, ""))
            .filter(Boolean);
        if (splitByHttp.length > 1)
            return splitByHttp;
        if (/^https?:\/\//i.test(raw))
            return [raw.replace(/^"+|"+$/g, "")];
        return [];
    }
    return [];
};
/**
 * Expands a single seed URL into a full set of rotator frames (8 angles).
 * Expects the seed URL to end with a 3-digit angle number before the extension,
 * e.g. "https://cdn.example.com/car_045.jpg".
 */
export const expandRotatorFramesFromSeed = (seedUrl) => {
    const clean = String(seedUrl || "").trim();
    const match = clean.match(/^(.*_)(\d{3})(\.[^/?#]+(?:\?[^#]*)?)$/i);
    if (!match)
        return clean ? [clean] : [];
    const [, prefix, , suffix] = match;
    const frames = [45, 90, 135, 180, 225, 270, 315, 360].map((angle) => `${prefix}${String(angle).padStart(3, "0")}${suffix}`);
    return frames;
};
